import styled from 'styled-components';

export const HiddenWrapper = styled.div`
  overflow: hidden;
`;

export const RadioOptionContainer = styled.section`
  background-image: ${(props) =>
    props.newDiaperVersion
      ? 'none'
      : 'linear-gradient(to bottom, #f8fcff, rgba(250, 250, 250, 0.44))'};
  margin: 0 auto;
  padding: 10px
    ${(props) => (props.experimentUserType === 'A' ? '15%' : '7.5%')};

  @media (max-width: 720px) {
    padding: 10px 0;
  }
`;

export const BestOfferTitle = styled.h6`
  padding: 10px 0 0;
  font-weight: 500;
  color: rgb(29 74 85 / 60%);
  letter-spacing: 0.24px;
  font-size: clamp(12px, 2vw, 15px);
  text-transform: uppercase;

  @media (max-width: 720px) {
    padding: 6px 12px 0 44px;
  }
`;

export const RadioOptionSection = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  margin-top: 44px;
  margin-bottom: 34px;
  @media (max-width: 720px) {
    display: block;
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export const CheckIcon = styled.span`
  width: 14px;
  height: 14px;
  display: inline-block;
  border: solid 1px #0101013d;
  border-radius: 50%;
  transition: 200ms linear;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    inset: 0;
    transform: scale(1.6);
    transition: 200ms linear;
    opacity: 0;
  }
`;

export const CardWrapper = styled.div`
  width: 100%;
  padding: 0 14px;
  margin: 8px 0;
  transition: 200ms linear;
  position: relative;

  @media (max-width: 720px) {
    margin: 0;
  }

  img {
    position: relative;
    top: 22px;
  }
`;

export const TemplateSection = styled.div`
  flex-basis: 44%;
  border: 2px dashed #63b0a8;
  border-radius: 6px;
  background: #fff;

  @media (max-width: 720px) {
    flex-basis: 100%;
    border: none;
    background: none;
  }
  .radioLabel {
    cursor: pointer;

    input[type='radio'] {
      display: none;

      &:checked + ${CardWrapper} {
        ${CheckIcon} {
          background: #ef4e5e;
          outline: 1px solid #ef4e5e;
          transform: scale(1.2);
          border: solid 2px #fff;
          width: 12px;
          height: 12px;

          &:before {
            transform: scale(1);
            opacity: 1;
          }
        }
      }
    }

    @media (max-width: 720px) {
      cursor: default;
    }
  }
`;

export const RadioCustomButton = styled.div`
  position: absolute;
  left: 20px;
  top: 19px;
`;

export const OfferCard = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 18px 10px 18px 32px;
  border: none;

  @media (max-width: 720px) {
    border-bottom: ${(props) =>
      props.lastElement ? 'none' : '1px solid #7070702e'};
  }
`;

export const OfferName = styled.h4`
  font-size: clamp(16px, 2vw, 18px);
  color: hsl(0deg, 0%, 0%, 87%);
`;

export const PerDiaperPrice = styled.span`
  display: inline-block;
  background-color: #a3e2ed66;
  padding: 3px 8px;
  margin: 4px 0;
  font-size: 11px;
  font-weight: 600;
  color: hsl(0deg, 0%, 0%, 72%);
  width: max-content;
  border-radius: 3px;
`;

export const PriceDiv = styled.div`
  display: flex;
  column-gap: 6px;
  align-items: center;
  padding-bottom: 3px;

  strong {
    font-size: clamp(16px, 2vw, 20px);
    color: hsl(0deg, 0%, 0%, 84%);
  }

  span {
    font-size: clamp(13px, 2vw, 16px);
    font-weight: 500;
    color: #999;
    text-decoration: line-through;
  }
`;

export const Discount = styled.div`
  font-size: clamp(12px, 2vw, 16px);
  font-weight: 600;
  color: #63b0a8;
  text-align: right;
`;

export const LighteningDealRibbon = styled.div`
  background-color: #555474;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  padding: 6px 22px 6px 10px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  position: absolute;
  height: 30px;
  width: max-content;
  top: -28px;
  @media (max-width: 720px) {
    padding: 8px 18px 8px 10px;
    font-size: 10px;
    height: 20px;
    top: 12px;
    left: 44px;
    position: relative;
  }

  img {
    width: 9px;
    height: 11px;
    margin-right: 4px;
  }

  &:after {
    content: '';
    position: absolute;
    height: 0;
    width: 0;
    border-width: 15px 8px;
    border-style: solid;
    border-color: #555474 #f8fcff #555474 #555474;
    top: 0px;
    right: 0px;

    @media (max-width: 720px) {
      border-width: 10px 8px;
    }
  }
`;

export const DiaperHeading = styled.h1`
  color: hsl(0deg, 0%, 0%, 80%);
  position: relative;
  font-size: clamp(20px, 2vw, 28px);
  font-weight: 600;
  text-transform: capitalize;
  display: flex;
  justify-content: center;
  padding: 10px 0 0 0;
  letter-spacing: 2px;
  @media (min-width: 720px) {
    padding: 15px;
    letter-spacing: 5px;
  }
`;

export const ViewInBanner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 20px 0 40px;
  @media (max-width: 720px) {
    margin: 20px 0 10px;
  }
  img {
    width: 33%;
    cursor: pointer;
    @media (max-width: 720px) {
      width: 100%;
    }
  }
  &.opacity {
    opacity: 0.4;
  }
`;
